export const EXECUTIVE_VIEWS = [
  { id: 'gerencial', label: 'Gerencial' },
  { id: 'luis-support', label: 'Soporte Luis' },
  { id: 'executive-support', label: 'Soporte gerencial' },
  { id: 'project-summary', label: 'Resumen por proyecto' },
  { id: 'actual-vs-budget', label: 'Avance real vs presupuesto' },
  { id: 'supplier-movements', label: 'Proveedores' },
  { id: 'customer-movements', label: 'Clientes' },
  { id: 'bank-movements', label: 'Bancos' },
  { id: 'purchase-order-general', label: 'General' },
  { id: 'purchase-order-detail', label: 'Detalle' },
  { id: 'gxc', label: 'GXC' },
  { id: 'cxm', label: 'CXM' },
  { id: 'opening-balances', label: 'Saldos iniciales' },
  { id: 'movement-ledger', label: 'Auxiliar de movimientos' },
] as const;

export type ExecutiveView = (typeof EXECUTIVE_VIEWS)[number]['id'];
